module.exports = __webpack_public_path__ + "static/media/dress-1.153c7ae7.jpg";